export interface TenantFeatures {
	additionalAssignment: boolean;
	specialization: boolean;
	caseGroup: boolean;
	legalBaseRequiredInP2: boolean; // The combination of the type of care, sponsor, legal base and case group is required in P2
	careRelatedDisabilityTypeRequiredInP2: boolean;
	additionalReports: boolean;
	dashboardNetworkContactOverviewVisible: boolean;
}

export const DEFAULT_TENANT_FEATURES: TenantFeatures = {
	additionalAssignment: true,
	specialization: true,
	caseGroup: true,
	legalBaseRequiredInP2: false,
	careRelatedDisabilityTypeRequiredInP2: false,
	additionalReports: false,
	dashboardNetworkContactOverviewVisible: true,
};

export const TENANT_FEATURE_OVERRIDES: Record<string, Partial<TenantFeatures>> = {
	// Keep tenant keys normalized so the auth claim can be matched directly.
	thue: {
		additionalAssignment: false,
		specialization: false,
		caseGroup: false,
		legalBaseRequiredInP2: true,
		careRelatedDisabilityTypeRequiredInP2: true,
		additionalReports: true,
		dashboardNetworkContactOverviewVisible: false,
	},
	sa: {
		additionalAssignment: false,
	},
	saa: {
		additionalAssignment: false,
		specialization: false,
	},
	bre: {
		legalBaseRequiredInP2: true,
	},
};

export const normalizeTenantKey = (tenantName: string | null | undefined): string | null => {
	const normalized = tenantName?.trim().toLowerCase();
	return normalized ? normalized : null;
};
